import { createSlice } from '@reduxjs/toolkit'
import { RootState } from 'store'
import {
  requestChallengeMediaUpload,
  confirmChallengeMediaUpload,
  getChallengeMedia,
  deleteChallengeMedia,
} from './thunks'

interface ChallengeMediaState {
  media: {
    [key: string]: string
  }
  loading: boolean
  error: unknown | null
}

const initialState: ChallengeMediaState = {
  media: {},
  loading: false,
  error: null,
}

const challengesMediaSlice = createSlice({
  name: 'challengesMedia',
  initialState,
  reducers: {
    resetChallengesMedia: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestChallengeMediaUpload.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(requestChallengeMediaUpload.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(requestChallengeMediaUpload.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(confirmChallengeMediaUpload.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(confirmChallengeMediaUpload.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(confirmChallengeMediaUpload.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(getChallengeMedia.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getChallengeMedia.fulfilled, (state, action) => {
        state.loading = false
        if (action.payload.data?.imageUrl) {
          state.media[action.meta.arg.challengeImageType] = action.payload.data.imageUrl
        }
      })
      .addCase(getChallengeMedia.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase(deleteChallengeMedia.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteChallengeMedia.fulfilled, (state, action) => {
        state.loading = false
        delete state.media[action.meta.arg.challengeImageType]
      })
      .addCase(deleteChallengeMedia.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetChallengesMedia } = challengesMediaSlice.actions

export const selectChallengesMedia = (state: RootState) => state.challengesMedia

export default challengesMediaSlice.reducer
